import {
  type OfferV11,
  PrescriptionV3PrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

export type ErxRecommendedRetailPrice = {
  currency: string | undefined
  price: number | undefined
}

/*
 * WSAWA-4276
 * We take the price located in offers[x].offerPrice.price as this will always be consistent across all products.
 * Other prices locations, like offers[x].prescriptionPriceMap, have the price already calculated to reflect specific scenarios (Prescription, Private Prescritpions, etc.)
 */
export const priceAccessorGetErxRecommendedRetailPrice = (
  offer: OfferV11,
  prescriptionType: PrescriptionV3PrescriptionTypeEnum,
): ErxRecommendedRetailPrice | null => {
  if (
    prescriptionType === PrescriptionV3PrescriptionTypeEnum.FreePrescription ||
    prescriptionType ===
      PrescriptionV3PrescriptionTypeEnum.InsurancePrescription
  ) {
    const price = offer.offerPrice?.price
    const currency = offer.offerPrice?.currency

    if (!price) {
      return null
    }

    return {
      currency,
      price,
    }
  }

  return null
}
